import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import { getTimeZone, secondsToTime } from '../../../utils/timeCalculation';
import { useStyles } from '../Style/infoSectionStyles';

const InfoSection = ({ totalTime, dateRange }) => {
  const classes = useStyles();
  const formattedTime = secondsToTime(totalTime);
  const selectedDateRange = `${dateRange?.selection?.startDate.toDateString()} - ${dateRange?.selection?.endDate.toDateString()}`;
  const userTimeZoneText = `UTC ${getTimeZone()}, ${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
  return (
    <div>
      <Typography className={classes.timeText}>Total time {formattedTime}</Typography>
      <Typography className={classes.dateText}>{selectedDateRange}</Typography>
      <Box className={classes.timeZoneContainer}>
        <SettingsIcon className={classes.settingsIcon} />
        <Typography style={{ fontSize: '14px', color: '#5469d4' }}>{userTimeZoneText}</Typography>
      </Box>
    </div>
  );
};

InfoSection.propTypes = {
  totalTime: PropTypes.number,
  dateRange: PropTypes.object,
};

export default InfoSection;
